/* R10 — service-state layer, ported from v16.
   Two edits, both at the edges; the states, the clock and every line of copy
   are v16 verbatim:
     1. `lang` comes from the active Shopify locale, not v16's review toggle.
     2. v16's #peek preview panel is rebuilt at the bottom of this file, opt-in
        only. See the comment there. */
(function(){
const lang = (document.documentElement.lang || 'de').slice(0,2);
let forced = null;     // v16 review override; null unless the preview panel sets it


const IMG = {
  arrival : "a0e142_29075b347b8c4e9bb5a67613dd8b38a2~mv2.png",
  guest   : "a0e142_7377e33180a5438e9712707b7b7f5d76f000.jpg",
  snack   : "a0e142_adcde50d90fc402e9751c0f3c8ff1bd2~mv2.png"
};
const src = (id, w, h) =>
  "https://static.wixstatic.com/media/" + id + "/v1/fill/w_" + w + ",h_" + h + ",al_c,q_88/h.jpg";

const RESOS = "#reserve";   // internal page hosting the resOS widget

/* Bar snacks launch — the first night is Friday 9 October 2026. Before this
   date the site trails the offer but the service state stays "bar": nobody is
   told snacks are on when they are not, and the 22:00 mark stays off the
   timeline. After it, everything switches on by itself.

   The trailing copy says "ab Oktober / from October" by Bez's decision, not the
   exact date. If the launch ever moves out of October, the two pre-launch lines
   below have to move with this constant — they are not derived from it. */
const SNACKS_FROM = new Date("2026-10-09T00:00:00");
const snacksLive = (d) => d >= SNACKS_FROM;

/* ---- service states ------------------------------------------------------
   Mo–Sa ab 17:30. Letzte Küchenbestellung 21:30.
   Bar: Mo–Do bis Mitternacht; Fr & Sa Bar Snacks 22:00–00:00,
   letzte Getränkebestellung 01:00 — das ist die Zeit, die zählt.
   SONNTAG GESCHLOSSEN.                                                     */
const STATES = {
  closed_today: { mode:"day",   img:"arrival" },
  before_open : { mode:"day",   img:"arrival" },
  dinner      : { mode:"day",   img:"arrival" },
  last_tables : { mode:"night", img:"arrival" },
  bar_snacks  : { mode:"night", img:"snack"   },
  bar         : { mode:"night", img:"guest"   },
  after_close : { mode:"night", img:"arrival" }
};

function serviceState(d){
  const day = d.getDay();                       // 0 = Sonntag
  const mins = d.getHours()*60 + d.getMinutes();
  if (mins < 5*60){                             // 00:00–04:59 belongs to the night before
    const prev = (day + 6) % 7;
    if (prev === 0) return "before_open";        // Monday small hours — Sunday was closed
    const close = (prev === 5 || prev === 6) ? 60 : 0;   // last drink orders 01:00
    return mins < close ? "bar" : "after_close";
  }
  if (day === 0) return "closed_today";          // Sundays closed
  if (mins < 17*60 + 30) return "before_open";
  if (mins < 21*60 + 30) return "dinner";
  if (mins < 22*60)      return "last_tables";
  return ((day === 5 || day === 6) && snacksLive(d)) ? "bar_snacks" : "bar";
}

/* Friday and Saturday, 21:30–22:00: the dinner kitchen is closing but the
   bar snacks start at ten, so the strip must not read like the night is over. */
const LAST_TABLES_WEEKEND = {
  de:{ now:"Bar Snacks ab 22 Uhr", sub:"Dinnerküche schließt",
    line:"Die Dinnerküche nimmt die letzten Bestellungen an. Bar Snacks ab 22 Uhr.", cta:"Bar Snacks reservieren", ctaS:"Reservieren" },
  en:{ now:"Bar snacks at 22:00", sub:"Dinner closing",
    line:"Dinner service closing, bar snacks starting 22:00.", cta:"Reserve bar snacks", ctaS:"Book" }
};

/* Sunday small hours run to Monday, not "later today" */
const WEEKEND_CLOSE = {
  de:{ now:"Geschlossen", sub:"Wieder Montag 17:30 Uhr", line:"Das war’s fürs Wochenende. Türen wieder am Montag um 17:30 Uhr." },
  en:{ now:"Closed", sub:"Open again Monday 17:30", line:"That’s us for the weekend. Doors again Monday at 17:30." }
};

function snackNote(d, state, lang){
  if (state === "bar_snacks") return "";
  if (!snacksLive(d))
    return lang === "de" ? "Bar Snacks ab Oktober — freitags & samstags, 22 bis 24 Uhr."
                         : "Bar snacks from October — Friday & Saturday, 22:00 to midnight.";
  const day = d.getDay(), mins = d.getHours()*60 + d.getMinutes();
  const tonight = (day === 5 || day === 6) && mins >= 5*60 && mins < 22*60;
  if (lang === "de") return tonight ? "Bar Snacks heute ab 22 Uhr."
                                    : "Bar Snacks: freitags & samstags, 22 bis 24 Uhr.";
  return tonight ? "Bar snacks from 22:00 tonight."
                 : "Bar snacks: Friday & Saturday, 22:00 to midnight.";
}

const SNACK_TAG = {
  de:{ pre:"Ab Oktober · Freitag &amp; Samstag · 22 bis 24 Uhr", live:"Freitag &amp; Samstag · 22 bis 24 Uhr" },
  en:{ pre:"From October · Friday &amp; Saturday · 22:00 – midnight", live:"Friday &amp; Saturday · 22:00 – midnight" }
};

function closingWord(d, lang){
  const day = d.getDay();
  const late = (day === 5 || day === 6) ||
               (d.getHours() < 5 && ((day + 6) % 7 === 5 || (day + 6) % 7 === 6));
  if (lang === "de") return late ? "eins" : "Mitternacht";
  return late ? "one" : "midnight";
}

/* The last hour before service.

   v16's before_open pair reads "Öffnet 17:30 / Küche ab 17:30 Uhr" — the same
   fact stated twice, and it never moves, so from five in the morning until half
   past five in the evening the strip is a caption rather than a live state.
   Inside the final hour the sub line counts down instead: the one stretch where
   the number actually changes something for the person reading it.

   Outside that hour v16's own copy comes back untouched, and every other state
   is left alone entirely. The small-hours before_open (Monday 00:00–04:59) is
   far more than an hour out, so it keeps v16's line too. */
function openingIn(d, state, lang, fallback){
  if (state !== "before_open") return fallback;
  const left = (17*60 + 30) - (d.getHours()*60 + d.getMinutes());
  if (left < 0 || left > 60) return fallback;
  if (left <= 1) return lang === "de" ? "Gleich" : "Any moment";
  return lang === "de" ? "In " + left + " Minuten" : "In " + left + " minutes";
}

/* The evening as a timeline — the bar's middle section.

   v16 carried a black box of times at the bottom of the screen and it was the
   most alive thing on the page. That box was #peek, a prototype control that
   forces the clock, so it can never face a guest. This is the same object built
   for one: same dark chips, same brick highlight, but reading the clock instead
   of overriding it, and carrying the evening's real shape rather than a
   developer's test times.

   The marks are Bez's, and the set changes with the day:

     Mon–Thu   17:30 kitchen open · 19:30 filling up · 20:30 peak ·
               21:30 full menu last orders · 00:00 last drinks
     Fri & Sat 17:30 kitchen open · 19:30 filling up · 20:30 peak ·
               21:30 full menu last orders · 22:00 snacks open · 01:00 last drinks

   21:30 is the last orders off the full menu, not the kitchen's close — those
   plates go out until 22:00 — so "Küche zu / Kitchen closed" was wrong on every
   night of the week, and on Friday and Saturday it collided with a snacks mark
   an hour later. Each mark now names what ends or begins: the full menu stops
   taking orders at 21:30, snacks start at 22:00 as the last plates leave, drinks
   run to the closing mark. That mark says drinks rather than orders on every
   day, because with a kitchen mark earlier in the same row "letzte Bestellung"
   left the guest to work out which orders were meant.

   The two languages part company at 21:30, and the reason is width, not
   meaning. English says "Full menu last orders"; German says "Letzte
   Bestellung", with "Snacks auf" an hour later carrying the contrast. "Karte
   letzte Bestellung" measures 934px against 914px of row and would blank every
   label — see below.

   Label length is not free. The row drops *all* labels the moment the times
   would clip (see paintHours), and measured in place at 1267px — 914px of row —
   the six-chip weekend set fits in both languages with about nothing to spare.
   "Letzte Küchenbestellung" came to 955px. Anything much past seventeen
   characters in German has to be measured before it ships.

   Three rules decide what is lit:

     · the filled chip is the block you are *in* — the last mark the clock has
       passed, not the next one coming;
     · before service, nothing is filled and the first mark is outlined instead,
       so the timeline is alive at eleven in the morning without claiming that
       anything is happening yet;
     · when the house is shut — Sunday, or after last orders — nothing is marked
       at all. The evening exists; it just is not tonight.

   The day is the *service* day, not the calendar day: at 00:30 on a Saturday
   you are still inside Friday's evening, so Friday's timeline is the one shown
   and the 01:00 mark is the one lit. The 22:00 snacks mark stays out entirely
   until SNACKS_FROM, so the bar never advertises a service that is not running.
*/
function serviceDay(d){
  const day = d.getDay();
  return d.getHours() < 5 ? (day + 6) % 7 : day;
}

function timeline(d, lang){
  const de = lang === "de";
  const day = serviceDay(d);
  const weekend = (day === 5 || day === 6);
  const marks = [
    { mins: 17*60 + 30, time: "17:30", label: de ? "Küche auf"         : "Kitchen open" },
    { mins: 19*60 + 30, time: "19:30", label: de ? "Es füllt sich"     : "Filling up" },
    { mins: 20*60 + 30, time: "20:30", label: de ? "Hochbetrieb"       : "Peak" },
    { mins: 21*60 + 30, time: "21:30", label: de ? "Letzte Dinnerbestellung" : "Last dinner order" }
  ];
  if (weekend && snacksLive(d))
    marks.push({ mins: 22*60, time: "22:00", label: "Bar Snacks" });
  marks.push({ mins:  weekend ? 25*60   : 24*60,
               time:  weekend ? "01:00" : "00:00",
               label: de ? "Letzte Drinks" : "Last drinks" });
  return marks;
}

function paintHours(d, lang, state){
  const box = document.querySelector('[data-hours]');
  if (!box) return;

  const marks = timeline(d, lang);
  const day = serviceDay(d);
  const weekend = (day === 5 || day === 6);
  const shut = (day === 0 || state === "closed_today" || state === "after_close");

  /* minutes since midnight, carried past it: 01:00 is 1500, not 60 */
  const nightMins = d.getHours()*60 + d.getMinutes() + (d.getHours() < 5 ? 24*60 : 0);

  let active = -1;
  if (!shut){
    marks.forEach(function(m, i){ if (nightMins >= m.mins) active = i; });
    /* Friday and Saturday, snacks stop at midnight but the bar runs to one, so
       past midnight the last mark is the one that is true. */
    if (weekend && nightMins >= 24*60) active = marks.length - 1;
  }

  box.textContent = "";
  marks.forEach(function(m, i){
    const chip = document.createElement("span");
    if (i === active) chip.setAttribute("data-now", "");
    else if (active === -1 && i === 0 && !shut) chip.setAttribute("data-next", "");
    const t = document.createElement("b");
    t.textContent = m.time;
    const l = document.createElement("i");
    l.className = "lbl";
    l.textContent = m.label;
    chip.appendChild(t);
    chip.appendChild(l);
    box.appendChild(chip);
  });

  /* Labels stay until they cannot. A breakpoint cannot decide this: the row is
     five chips Monday to Thursday and six on Friday, the German labels are
     longer than the English, and six labelled chips need 880px against 893px of
     row at 1267 — thirteen pixels of margin. So the row measures itself and
     drops the labels only when the times would otherwise be clipped, which is
     also why it is re-run on resize. */
  box.classList.remove("tight");
  if (box.scrollWidth > box.clientWidth) box.classList.add("tight");
}

const COPY = {
  de:{
    closed_today:{ now:"Heute geschlossen", sub:"Wieder Montag 17:30 Uhr",
      line:"Sonntags haben wir geschlossen. Ab Montag wieder ab 17:30 Uhr.", cta:"Tisch reservieren", ctaS:"Reservieren", href:RESOS },
    before_open :{ now:"Öffnet 17:30",      sub:"Küche ab 17:30 Uhr",
      line:"Wir öffnen um 17:30 Uhr.", cta:"Tisch reservieren", ctaS:"Reservieren", href:RESOS },
    dinner      :{ now:"Geöffnet",          sub:"Letzte Dinnerbestellung 21:30",
      line:"Die Küche ist offen. Letzte Dinnerbestellung um 21:30 Uhr.", cta:"Tisch reservieren", ctaS:"Reservieren", href:RESOS },
    last_tables :{ now:"Bar geöffnet", sub:"Bar bis Mitternacht",
      line:"Die Küche hat die letzten Bestellungen aufgenommen. Die Bar macht weiter.", cta:"Anderen Abend buchen", ctaS:"Buchen", href:RESOS },
    bar_snacks  :{ now:"Bar Snacks",        sub:"Bis Mitternacht",
      line:"Die Dinnerküche ist zu, die Bar-Snack-Karte läuft bis Mitternacht. Einfach reinkommen.", cta:"Zur Snack-Karte", ctaS:"Snacks", href:"#menu" },
    bar         :{ now:"Bar geöffnet",      sub:"Küche geschlossen",
      line:"Die Küche ist geschlossen, aber die Bar hat noch geöffnet. Letzte Bestellung um {close} — einfach reinkommen.", cta:"Zur Cocktailkarte", ctaS:"Cocktails", href:"#menu" },
    after_close :{ now:"Geschlossen",       sub:"Wieder ab 17:30 Uhr",
      line:"Das war’s für heute. Türen wieder um 17:30 Uhr.", cta:"Tisch reservieren", ctaS:"Reservieren", href:RESOS }
  },
  en:{
    closed_today:{ now:"Closed today",  sub:"Open again Monday 17:30",
      line:"We are closed on Sundays. Back Monday from 17:30.", cta:"Reserve a table", ctaS:"Reserve", href:RESOS },
    before_open :{ now:"Opens 17:30",   sub:"Kitchen from 17:30",
      line:"We open at 17:30.", cta:"Reserve a table", ctaS:"Reserve", href:RESOS },
    dinner      :{ now:"Open",          sub:"Last dinner order 21:30",
      line:"Kitchen’s open. Last dinner order 21:30.", cta:"Reserve a table", ctaS:"Reserve", href:RESOS },
    last_tables :{ now:"Bar open",   sub:"Bar until midnight",
      line:"The kitchen has taken its last orders. The bar carries on.", cta:"Book another night", ctaS:"Book", href:RESOS },
    bar_snacks  :{ now:"Bar snacks",    sub:"Until midnight",
      line:"Dinner service is over; bar snacks until midnight. Walk in.", cta:"See the snacks", ctaS:"Snacks", href:"#menu" },
    bar         :{ now:"Bar open",      sub:"Kitchen closed",
      line:"Kitchen closed, but the bar’s still open. Last orders at {close} — walk in.", cta:"See the cocktail list", ctaS:"Cocktails", href:"#menu" },
    after_close :{ now:"Closed",        sub:"Open again 17:30",
      line:"That’s us for tonight. Doors again at 17:30.", cta:"Reserve a table", ctaS:"Reserve", href:RESOS }
  }
};

function fill(slot, v){ document.querySelectorAll('[data-slot="'+slot+'"]').forEach(el=>el.textContent = v); }

function render(){
  const now = new Date();
  const state = forced || serviceState(now);
  const conf = STATES[state];
  const wkndLast = state === "last_tables" && (now.getDay() === 5 || now.getDay() === 6) && snacksLive(now);
  const c = wkndLast ? LAST_TABLES_WEEKEND[lang] : COPY[lang][state];
  root.dataset.state = state;
  root.dataset.mode  = conf.mode;

  const wk = (state === "after_close" && now.getDay() === 0) ? WEEKEND_CLOSE[lang] : null;
  fill('statusNow', wk ? wk.now : c.now);
  fill('statusSub', wk ? wk.sub : openingIn(now, state, lang, c.sub));
  fill('nowLine',  (wk ? wk.line : c.line).replace('{close}', closingWord(now, lang)));
  fill('nextLine', snackNote(now, state, lang));
  paintHours(now, lang, state);
  document.querySelectorAll('[data-slot="snackTag"]').forEach(el=>
    el.innerHTML = SNACK_TAG[lang][snacksLive(now) ? 'live' : 'pre']);
  fill('ctaLabel', c.cta);
  fill('ctaLabelShort', c.ctaS);


}

const root = document.documentElement;
render();
setInterval(render, 60000);

/* The timeline's fit depends on the width of the window, so re-measure when
   that changes. Debounced: a drag across a desktop fires this continuously. */
let resizeTimer = null;
window.addEventListener('resize', function(){
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(render, 150);
});

/* ---- v16's preview control (#peek) ---------------------------------------
   v16 carried a small fixed panel at bottom-left that forced the service
   state, so the whole time-aware design could be reviewed at 11am without
   waiting for 17:30 on a Friday. Its styling came across with r10.css — the
   #peek rules, including the bottom:86px nudge that lifts it above the mobile
   bar — but the markup never did, because v16 labels it "prototype-only
   review control" and a dev widget must never appear in front of a guest.

   So it is built here in JavaScript, never in the page source, and only when
   it is explicitly asked for: put ?peek=1 on any URL. The answer is kept in
   sessionStorage, so it survives clicking around that tab and dies when the
   tab closes. ?peek=0 or the ✕ clears it. A visitor who never types ?peek=1
   is served no markup, no listeners and no trace of it — which is why this
   needs no theme setting and nothing to remember to switch off before launch.

   The eight states and their labels are v16's, unchanged. "Live" releases the
   override and hands the site back to the clock. */
const PEEK_STATES = [
  ['live', 'Live'], ['before_open', '16:00'], ['dinner', '19:30'],
  ['last_tables', '21:40'], ['bar_snacks', 'Fr 22:30'], ['bar', 'Mi 23:30'],
  ['after_close', '03:00'], ['closed_today', 'So']
];

function peekWanted(){
  try{
    const q = new URLSearchParams(location.search).get('peek');
    if (q === '1'){ sessionStorage.setItem('r10-peek', '1'); return true; }
    if (q === '0'){ sessionStorage.removeItem('r10-peek'); return false; }
    return sessionStorage.getItem('r10-peek') === '1';
  }catch(e){ return false; }   // private mode, blocked storage — just stay hidden
}

function buildPeek(){
  if (document.getElementById('peek')) return;
  const box = document.createElement('div');
  box.id = 'peek';

  const label = document.createElement('b');
  label.textContent = 'Preview';
  box.appendChild(label);

  PEEK_STATES.forEach(function(pair){
    const key = pair[0], text = pair[1];
    const btn = document.createElement('button');
    btn.dataset.peek = key;
    btn.textContent = text;
    btn.setAttribute('aria-pressed', key === 'live' ? 'true' : 'false');
    btn.addEventListener('click', function(){
      forced = (key === 'live') ? null : key;
      box.querySelectorAll('button[data-peek]').forEach(function(other){
        other.setAttribute('aria-pressed', other === btn ? 'true' : 'false');
      });
      render();
    });
    box.appendChild(btn);
  });

  const close = document.createElement('button');
  close.className = 'x';
  close.textContent = '✕';
  close.title = 'Ausblenden';
  close.addEventListener('click', function(){
    try{ sessionStorage.removeItem('r10-peek'); }catch(e){}
    forced = null;
    box.remove();
    render();
  });
  box.appendChild(close);

  document.body.appendChild(box);
}

if (peekWanted()) buildPeek();
})();
